import React, { useEffect, useState } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import axios from 'axios';
import Env from '../../hooks/Env';

const CepecEmail = () => {
    const { API_URL } = Env();
    const navigate = useNavigate();
    const { search } = useLocation();
    const [message, setMessage] = useState('');

    useEffect(() => {
        const params = new URLSearchParams(search);
        const email = params.get('email');
        if (!email) {
            setMessage('Email manquant');
            // redirect to main certificate page without params after short delay
            setTimeout(() => navigate('/certificat'), 1500);
            return;
        }
        const ANNEE_UNIVERSITE = Env().ANNEE_UNIVERSITE;
        // Confirm payment with backend using admission path with email and year
        const url = `${API_URL}/paiement/confirmed/cepec/${encodeURIComponent(email)}/${encodeURIComponent(ANNEE_UNIVERSITE)}`;
        axios.get(url)
            .then(res => {
                if (res?.data?.detail) {
                    // setMessage(res.data.detail);
                    navigate(`/certificat`);
                } else {
                    navigate(`/certificat?email=${encodeURIComponent(email)}&paid=true`);
                }
            })
            .catch(err => {
                console.error('Error confirming payment:', err);
                navigate(`/certificat?email=${encodeURIComponent(email)}&paid=false`);
            });
    }, [search, API_URL, navigate]);

    return (
        <div style={{padding:20}}>
            <p>Vérification du paiement en cours...</p>
            {message ? <p style={{color:'red'}}>{message}</p> : null}
        </div>
    );
}

export default CepecEmail;
